<template>
    <div class="section">
        <b-modal :can-cancel="false" :active.sync="cartSuccessModal" scroll="keep">
            <div class="modal-card" style="width: auto; max-width:600px; margin: 0 auto;">
                <div class="modal-card-body has-text-centered">
                    <div class="columns is-multiline">
                        <div class="column has-text-centered is-full">
                            <b-icon class="m-b-10 is-custom-text" icon="check" size="is-large"></b-icon>
                            <p class="is-size-4">
                                Producto añadido a tu compra exitosamente!
                            </p>
                        </div>
                        <div class="column has-text-centered is-full">
                            
                            <b-button
                            type="is-light"
                            rounded
                            @click="cartSuccessModal=false">
                                Seguir comprando
                            </b-button>
                            
                            <a
                            class="button is-rounded is-custom"
                            :href="checkoutTemplate"
                            >
                                Terminar la compra
                            </a>
                            
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>

        <div class="columns is-centered">
            <div class="column is-full">
                <Breadcrumbs
                :product="product"
                />
            </div>
        </div>

        <div class="columns">
            <div class="column is-half">
                <Gallery 
                :images="product.images"/>
                
            </div>
            <div class="column is-half">
                <!-- Product detials. price titiel and description -->
                <h1 class="is-title is-size-3">{{product.title}}</h1>
                
                <div class="tags">
                    <b-tag v-if="warrantyBool" type="is-success-notify">{{product.warranty}}</b-tag>
                    <b-tag v-if="product.hasDelay" class="is-warning-notify">
                        Este producto puede tener demoras a la hora de llegar a tus manos.
                    </b-tag>
                </div>
                <p>
                    <span v-if="product.status == 'O'"
                    class="compare-at">
                        {{product.currencySymbol}} {{compareAtDisplay}}
                    </span>
                </p>
                <span class="is-size-4 is-custom-text has-text-weight-bold">
                    {{product.currencySymbol}} {{cartItem.unitPrice}}
                </span>
                <span v-if="displaySku === 'True'" class="heading">{{product.code}}</span>
                <MpInstallments
                v-if="mpChannel == 'True'"
                :currency="product.currencySymbol"
                :price="cartItem.unitPrice"
                />
                
                <!-- Product attributes form. -->
                <p v-for="attr in product.attributes" :key="attr.id">
                    <span class="has-text-weight-semibold">{{attr.title}}</span>
                    <b-field>
                        <b-radio-button
                            v-for="val in attr.values"
                            v-model="selectedValues[attr.title]"
                            :key="val.id"
                            :native-value="val.id"
                            type="is-success"
                            @input="attrChange">
                            <span>{{val.title}}</span>
                        </b-radio-button>
                    </b-field>
                </p>
                <!-- Product quantity and add to cart button. -->
                <b-field v-if="!product.classified" class="m-t-20">
                    
                    <b-numberinput
                        :editable="false"
                        rounded
                        constrols-position="compact"
                        v-model="cartItem.quantity"
                        min="1"
                        type="is-light"
                    >
                    </b-numberinput>

                    <p class="control">
                        <b-button
                        :loading="addButtonLoad"
                        class="is-custom"
                        :disabled="saveButtonDisabled"
                        @click="sendItem"
                        >
                        Agregar al carrito
                        </b-button>
                    </p>
                </b-field>

                <ClassifiedControls 
                    v-else
                    :authUser="authUser"
                    :classifiedUrl="classifiedUrl"
                    :product="product"/>

                
                
                <Envios v-if="envios.length" :envios="envios"/>    
            </div>
        </div>
        <hr>
        <div class="columns is-centered">
            <div class="column is-two-thirds">
                <div class="description-box">
                    <div class="ql-editor" v-html="product.description"></div>
                </div>
            </div>
        </div>
        <Related v-if="section && section.products.length > 1" :products="section.products.filter((el)=>{return el.id != this.product.id})" :prodId="product.id"/>
    </div>
</template>

<script>
import {getHandler, postHandler} from "./../../../services/http"
import Gallery from "./components/Gallery.vue"
import Envios from "./components/Envios.vue"
import ClassifiedControls from "./components/ClassifiedControls.vue"
import MpInstallments from "./components/MpInstallments.vue"
import Breadcrumbs from "./components/Breadcrumbs.vue"
import Related from "./components/Related.vue"
 // import theme style
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
export default {
    components:{
        Gallery,
        Envios,
        ClassifiedControls,
        MpInstallments,
        Breadcrumbs,
        Related
    },
    props:{
        prodUrl:{
            type:String,
            default:""
        },
        cartItemUrl:{
            type:String,
            default:""
        },
        cartDetail:{
            type:String,
            default:""
        },
        shipmentListUrl:{
            type:String,
            default:""
        },
        classifiedUrl:{
            type:String,
            default:""
        },
        authUser:{
            type:String,
            default:""
        },
        mpChannel:{
            type:String,
            default:""
        },
        displaySku:{
            type:String,
            default:""
        },
        checkoutTemplate:{
            type:String,
            default:""
        },
        relatedProductsUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            addButtonLoad:false,
            saveButtonDisabled:false,
            product:{},
            selectedValues:{},
            cartItem:{
                product:"",
                values:[],
                variant:"",
                quantity:1,
                unitPrice:""
            },
            compareAtDisplay:0,
            cartSuccessModal:false,
            envios:[],
            isDelayActive:true,
            section:{}
        }
    },
    methods:{
        async fetchDetail(){
            this.loading = true
            this.product = await getHandler(this.prodUrl, {error:false, success:false})
            console.log(this.product)
            this.loading = false
            this.cartItem.product = this.product.id
            this.cartItem.unitPrice = this.product.price
            this.compareAtDisplay = this.product.compareAt
            if(this.product.attributes.length){
                this.saveButtonDisabled = true
            } else{
                this.saveButtonDisabled = false
            }
        },
        async fetchSection(){
            var response = await getHandler(this.relatedProductsUrl, {error:false, success:false})
            this.section = response
        },
        attrChange(){
            var arr = []
            for (let index in this.product.attributes){
                var el = this.product.attributes[index]
                if(this.selectedValues[el.title]){
                    arr.push(this.selectedValues[el.title])
                }
            }
            console.log(arr)
            if(this.product.attributes.length == arr.length){
                this.saveButtonDisabled=false
                this.cartItem.values = arr
                console.log(arr)
                let variante = this.product.variants.find(
                    (variant)=>{
                        return variant.values.every(
                            (value)=>{
                                return arr.includes(value) === true                          
                            } 
                        )
                    }
                )
                if (variante){
                    this.cartItem.variant = variante.id
                    this.cartItem.quantity = 1
                    this.cartItem.unitPrice = this.product.price
                    this.compareAtDisplay = this.product.compareAt
                    if(variante.hasDifPricing){
                        this.cartItem.unitPrice = variante.price
                        this.compareAtDisplay = variante.compareAt
                    }
                    
                } else {
                    this.cartItem.quantity = 1
                    this.cartItem.variant = null
                    this.cartItem.unitPrice = this.product.price
                }
            } else{
                this.saveButtonDisabled = true
            }
            
        },
        async sendItem(){
            this.addButtonLoad = true
            let msgErr = {
                resource:'notify',
                text:"Parece que ya tienes este producto en el carrito! ve al carro y editalo."
            }
            let resp = await postHandler(this.cartItemUrl, this.cartItem, {error:msgErr, success:false})
            if (resp.status <= 201){
                this.cartSuccessModal = true
            }
            this.addButtonLoad = false
            localStorage.setItem("cartCount", resp.data.cartCount)
            var event = document.createEvent("Event");
            event.initEvent("storage", true, true);
            window.dispatchEvent(event);
            
        },
        async fetchEnvios(){
            var resp = await getHandler(this.shipmentListUrl, {error:false, success:false})
            this.envios = resp
        }
    },
    computed:{
        quantityMax(){
            var max = undefined
            if(this.product.trackStock){
                if (this.cartItem.variant){
                    let el = this.product.variants.find(ele=>{return ele.id == this.cartItem.variant})
                    max = el.stockkeepingunit.quantity
                } else{
                    max = this.product.mainSku.totalSkus
                }
                if (max == 0){
                    this.saveButtonDisabled = true
                }
            }
            return max
        },
        warrantyBool(){
            if(this.product.warranty){
                return this.product.warranty.length > 0
            }else{
                return false
            }
        },


    },
    created(){
        this.fetchDetail()
        this.fetchEnvios()
        this.fetchSection()
    }
}
</script>

<style lang="scss" scoped>


.is-warning-notify{
    background-color:rgb(250, 241, 206);
}

.is-success-notify{
    background-color: rgb(154, 219, 177);
    color:rgb(35, 85, 35);
}

.is-custom-text{
    color:var(--primary);
}
.is-custom{
    background:var(--primary);
    color:var(--text-color);
}
.compare-at{
    text-decoration: line-through;
}
.description-box{
    max-height:700px;
    overflow-y: scroll;
}

.modal-card-body{
    border-radius:10px;
}
</style>